import '../css/module_offer.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import Tab from 'bootstrap/js/dist/tab'

import {disableModalOpenCheck, doLast} from './module_last';
import { firebaseSendSignInLinkToEmail, initFirebaseApp } from './module_firebase';
import { 
    handleUserLoginWithCallbackNoPremium,
    manageLogin, 
    openModalAndGotoUrl, 
    setRedirectAfterLogin,
} from './module_auth_helper';

import {
    funnelUpdateWhenAvailable,
    userIsLogged,
    userIsPremium,
    premiumSubscribeMsg,
    genericRetryErrMsg,
    updateBuyButtonCta,
    doSelectPlan,
    successNotification,
    alertNotification,
    hideSpinner,
    protectedApiCallRetry,
    showSpinner,
    sentryAPIErrorV2,
    signinModalId,
    websiteUrl,
    apiCallRetry,
    requestForModalOnNextPage,
} from './module_common'

import {
    getThankyoupageUrl,
    doNotRedirectToProfileOnProblemSendingEmailModalClose,
} from './module_checkout_helper'

import './module_common_actions';
import {sendMagnetData} from "./module_api_call";
import { 
    attachHeaderBuyButtonClick, 
    attachToCheckoutButtonClick, 
    handleMobileBottomCtaButton, 
    manageBuyButtonClick, 
    offerStandardInit, 
    reviewCarouselSetUp
} from './module_landing_offer_common';

class OfferPageError extends Error {
    constructor(...params) {
        super(...params);
        this.name = "OfferPageError"
    }
}

// used for freemium-template
let isLogged = userIsLogged
let isPremium = userIsPremium

function setLogged(){
    isLogged = true
}

function setPremium(){
    isPremium = true
}

const planSelect = function(plan){
    // planAttributes is defined in bundle template
    coupon = planAttributes[plan].coupon

    // selectedPlan updated here
    doSelectPlan(plan, "")
}

function attachPlanChange(){
    const els = document.querySelectorAll(".planselectbtn-ref")
    els.forEach((button) => {
        button.addEventListener('click', (e) => {
            const el = e.currentTarget
            const plan = window[el.dataset.plan]
            $(".navbar-button-cta-ref").text(el.dataset.cta)
            planSelect(plan)
        })
    })
}

function attachBundleV2BuyButtonClick(){
    $('.buy-btn-attach-clk-plans').on('click', function(e){
        const planRef = $(e.currentTarget).parent().data('plan')
        const plan = window[planRef]
        coupon = planAttributes[plan].coupon
        selectedPlan = plan
        manageBuyButtonClick()
    })
    $('.buy-btn-attach-clk').on('click', function(e){
        scrollTo(0,0);
    })
}

function attachHeaderBuyButtonClickFreemiumOffer(){
    $('.header-subscribe-btn-attach-clk').on('click', function(e){
        manageBuyButtonClickFreemiumOffer()
    })
}
function attachBuyButtonClickFreemiumOffer(){
    $('.buy-btn-attach-clk').on('click', function(e){
        manageBuyButtonClickFreemiumOffer()
    })
}

async function handleStartFreemiumOldEndpoint(){ 
    showSpinner()
    let url = '/2024/offers/bf_freemium_request?platform=web'
    if (icAttr && icAttr !== ''){
        url += '&tag='+icAttr
    }
    let freemiumResponse
    try {
        freemiumResponse = await protectedApiCallRetry('GET', url, null, 3)
    } catch (error) {
        hideSpinner()
        alertNotification(genericRetryErrMsg)
        const err = new OfferPageError("Error during freemium call", {cause: error})
        const contextData = {data: {user_id: UIDg}}
        sentryAPIErrorV2(err, contextData)
        return
    }
    hideSpinner()
    let redUrl = getThankyoupageUrl()
    if (!redUrl) redUrl = "/"+LL

    window.location = redUrl
}

async function handleStartFreemium(guest = false){ 
    showSpinner()
    if (!UIDg && !guest){
        hideSpinner()
        alertNotification(genericRetryErrMsg)
        return;
    }
    const uid = guest ? guestHash.split("-")[0] : UIDg
    let url = `/users/${uid}/freemium_request`
    if (guest) url = `/guests/${uid}/freemium_request?uem=${guestHash}`
    if (icAttr && icAttr !== ''){
        url += guest ? '&tag='+icAttr : '?tag='+icAttr
    }
    let freemiumResponse
    try {
        if (guest){
            freemiumResponse = await apiCallRetry('POST', url, {}, 3)
        }else{
            freemiumResponse = await protectedApiCallRetry('POST', url, {}, 3)
        }
    } catch (error) {
        hideSpinner()
        alertNotification(genericRetryErrMsg)
        const err = new OfferPageError("Error during freemium call", {cause: error})
        const contextData = {data: {user_id: uid}}
        sentryAPIErrorV2(err, contextData)
        return
    }
    hideSpinner()
    let redUrl = getThankyoupageUrl()
    if (!redUrl) redUrl = "/"+LL

    // be sure that the page after thankyoupage load the congratsGuestModal modal
    // and js call manageWelcomeGuestPremium method
    if (guest && typeof guestEmail !== 'undefined') {
        sessionStorage.setItem("showGuestCongratsModal", "ok");
        sessionStorage.setItem("guestEmail", guestEmail)
    }

    window.location = redUrl
}

async function manageBuyButtonClickFreemiumOffer(){
    if (isLogged){
        if (isPremium){
            successNotification(premiumSubscribeMsg)
        }else{
            handleStartFreemium()
        }
    }else{
        if (
            typeof usrCanSubscribe !== 'undefined' && 
            usrCanSubscribe &&
            typeof guestHash !== 'undefined'
        ){
            handleStartFreemium(true)
        }else{
            setRedirectAfterLogin(false)
            doNotRedirectToProfileOnProblemSendingEmailModalClose()
            const loginHandler = handleUserLoginWithCallbackNoPremium(
                handleStartFreemium, 
                premiumSubscribeMsg,
                setLogged,
                setPremium
            )
            document.body.addEventListener("userLogged", loginHandler)
            // dont use openSignInModal, there might be some logic 
            // to changing the login flow
            openModalAndGotoUrl(signinModalId)
        }
    }
}

function onLeadSubmit(){
    const goToThank = function(res){
        let bUrl = getThankyoupageUrl()
        if (res['hash']){
            if (bUrl.includes("?")){
                bUrl += "&"
            } else {
                bUrl += "?"
            }
            bUrl += "sess=" + res['user_id'] + '-' + res['hash'];
        }
        window.location = bUrl
    }

    const formEl = document.getElementById('magnet-form')
    let formData = new FormData(formEl)
    const leadEmail = formData.get('email')
    const ep = "/it/_ajax/abbonati/ajlead"
    showSpinner()

    // set also variable in subscribe.php
    let sendCustomEmail = true

    fetch(ep, {
        method: 'POST',
        body: new URLSearchParams(formData)
    }).then((resp) => {
        //   enableSubmit()
        hideSpinner()
        return resp.json()
    }).then((rs) => {
        if (!rs.done) throw new Error("ajlead not done");
        grecaptcha.reset()
        
        if (sendCustomEmail) {
            goToThank(rs)
        }else{
            // old, default firebase mail
            if (rs.is_new && !rs.verified){
                // queryparams hash is need by app.js to get user email from sparta
                const verificationUrl = `${websiteUrl()}${LL}/verifyemaillink?hash=${rs.user_id}-${rs.hash}`
                const actionCodeSettings = {
                    url: verificationUrl,
                    handleCodeInApp: true,
                }
                firebaseSendSignInLinkToEmail(leadEmail, actionCodeSettings)
                    .then(()=>{
                        // after click on email-link, the user will be redirected to /verifyemaillink
                        // manage by app.js
                        goToThank(rs)
                    })
                    .catch((err)=>{
                        alertNotification(genericRetryErrMsg)
                        const error = new OfferPageError("Error during sendSignInLinkToEmail call", {cause: err})
                        const contextData = {data: {user: leadEmail}}
                        sentryAPIErrorV2(error, contextData)
                    })
            }else{
                goToThank(rs)
            }
        }
        
    }).catch((error) => {
        hideSpinner()
        alertNotification(messages['genericApiError'])
        const contextData = {
            apicalldata:{
                function: "onLeadSubmit",
                url: ep,
                method: 'POST',
                status: error.status,
                response: error.responseJSON,
            }
        }
        const err= new Error('onLeadSubmit error')
        err.name = 'onLeadSubmit fail'
        sentryAPIErrorV2(err, contextData)
    });
}

window.onLeadSubmit = onLeadSubmit

function manageSendMagnetData(){
    // after grecaptcha is executed, 
    // the onLeadSubmit (see html template) will be launched
    grecaptcha.execute()
}

function manageSendMagnetData_OLD(){
    const goToThank = function(res){
        let bUrl = getThankyoupageUrl()
        if (res['hash']){
            if (bUrl.includes("?")){
                bUrl += "&"
            } else {
                bUrl += "?"
            }
            bUrl += "sess=" + res['user_id'] + '-' + res['hash'];
        }
        window.location = bUrl
    }
    const formEl = document.getElementById('magnet-form')
    let formData = new FormData(formEl)
    const leadEmail = formData.get('email')
    sendMagnetData(leadEmail, formData.get('extAttr'))
        .then(rs => {
            if (rs.is_new && !rs.verified){
                // queryparams hash is need by app.js to get user email from sparta
                const verificationUrl = `${websiteUrl()}${LL}/verifyemaillink?hash=${rs.user_id}-${rs.hash}`

                const actionCodeSettings = {
                    url: verificationUrl,
                    handleCodeInApp: true,
                }
                firebaseSendSignInLinkToEmail(leadEmail, actionCodeSettings)
                    .then(()=>{
                        // after click on email-link, the user will be redirected to /verifyemaillink
                        // manage by app.js
                        goToThank(rs)
                    })
                    .catch((err)=>{
                        alertNotification(genericRetryErrMsg)
                        const error = new OfferPageError("Error during sendSignInLinkToEmail call", {cause: err})
                        const contextData = {data: {user: leadEmail}}
                        sentryAPIErrorV2(error, contextData)
                    })
            }else{
                goToThank(rs)
            }
        })
        .catch(() => {
            // sentry message already sent by sendMagnetData
            alertNotification(genericRetryErrMsg)
        })
}

function attachMagnetEmailSend(){
    const formEl = document.getElementById('magnet-form')
    const magnetBtnSend = $('.magnet-btn-attach-clk')
    const manageClick = function(e){
        if (magnetBtnSend.hasClass('disabled')) return
        e.preventDefault();
        e.stopPropagation();
        if (formEl.checkValidity() === false) {
            formEl.classList.add('was-validated');
        }else{
            magnetBtnSend.addClass('disabled')
            manageSendMagnetData()
        }
    }
    magnetBtnSend.on('click', function(e){
        manageClick(e)
    })
    $('#magnet-form').on('submit', function(e){
        manageClick(e)
    })
}

function showExpiredOffer(){
    $(".timer-expired-box-ref").removeClass("offer-hidden")
    $(".timer-box-wrap-ref").addClass("offer-hidden")
}
function updateTimerEl(val, upperVal, selector){
    if (val || upperVal){
        $(selector+" .timer-val-ref").text(val)
    }else{
        if (selector.includes("seconds-ref")){
            // timer end
            showExpiredOffer()
            if (timerId) clearInterval(timerId)
            return
        }else{
            $(selector).addClass("offer-hidden")
        }
    }
}
function updateOfferTimer(){
    const now = new Date()
    let difference = offerTimerEnd*1000 - now.getTime();

    if (difference < 0){
        showExpiredOffer()
        if (timerId) clearInterval(timerId)
        return
    }

    const daysDiff = Math.floor(difference/1000/60/60/24);
    difference -= daysDiff*1000*60*60*24

    const hoursDiff = Math.floor(difference/1000/60/60);
    difference -= hoursDiff*1000*60*60

    const minutesDiff = Math.floor(difference/1000/60);
    difference -= minutesDiff*1000*60

    const secondsDiff = Math.floor(difference/1000);

    updateTimerEl(daysDiff, false, ".timer-box-wrap-ref .days-ref")
    updateTimerEl(hoursDiff, daysDiff, ".timer-box-wrap-ref .hours-ref")
    updateTimerEl(minutesDiff, hoursDiff || daysDiff , ".timer-box-wrap-ref .minutes-ref")
    updateTimerEl(secondsDiff, minutesDiff || hoursDiff || daysDiff, ".timer-box-wrap-ref .seconds-ref")
    // remove hidden, maybe in twig template the timer is hidden and we want to show when is ready
    $(".timer-box-wrap-ref").removeClass("offer-hidden")
}

function updateOfferTimerNoDays(){
    const now = new Date()
    let difference = offerTimerEnd*1000 - now.getTime();

    if (difference < 0){
        $(".timer-box-nodays-wrap-ref").addClass("offer-hidden")
        if (timerIdNoDays) clearInterval(timerIdNoDays)
        return
    }

    const daysDiff = Math.floor(difference/1000/60/60/24);
    difference -= daysDiff*1000*60*60*24

    const hoursDiff = Math.floor(difference/1000/60/60);
    difference -= hoursDiff*1000*60*60

    const minutesDiff = Math.floor(difference/1000/60);
    difference -= minutesDiff*1000*60

    const secondsDiff = Math.floor(difference/1000);

    updateTimerEl(hoursDiff  + daysDiff * 24, false, ".timer-box-nodays-wrap-ref .hours-ref")
    updateTimerEl(minutesDiff, hoursDiff , ".timer-box-nodays-wrap-ref .minutes-ref")
    updateTimerEl(secondsDiff, minutesDiff || hoursDiff, ".timer-box-nodays-wrap-ref .seconds-ref")
    // remove hidden, maybe in twig template the timer is hidden and we want to show when is ready
    $(".timer-box-nodays-wrap-ref").removeClass("offer-hidden")
}

let timerId;
let timerIdNoDays;

function handleOfferTimer(){
    if (typeof offerTimerEnd == 'undefined' || !offerTimerEnd) return
    updateOfferTimer()
    
    timerId = setInterval(updateOfferTimer, 1000)
}

function handleOfferTimerNoDays(){
    if (typeof offerTimerEnd == 'undefined' || !offerTimerEnd) return
    updateOfferTimerNoDays()
    
    timerIdNoDays = setInterval(updateOfferTimerNoDays, 1000)
}

function setCongratsForGuest(){
    const wantCongratsModal = sessionStorage.getItem("showGuestCongratsModal")
    const guestMail = sessionStorage.getItem("guestEmail")
    if (wantCongratsModal && guestMail){
        const data = {
            key: "guestusr",
            value: guestMail
        }
        requestForModalOnNextPage('CongratsGuestModal', data)
        sessionStorage.removeItem("showGuestCongratsModal")
        sessionStorage.removeItem("guestEmail")
    }
}

function initThankyouPage(){
    disableModalOpenCheck()
    attachHeaderBuyButtonClick()
    attachToCheckoutButtonClick()
    setCongratsForGuest()
    doLast()
}

function initDefaultOffer(){
    offerStandardInit()

    handleOfferTimer()
    handleOfferTimerNoDays()
    doLast()
}

function initBlackFriday2020Offer(){
    offerStandardInit()

    handleOfferTimer()
    handleOfferTimerNoDays()
    doLast()
}

function initBundleOffer(){
    offerStandardInit()

    attachPlanChange()
    handleOfferTimer()
    handleOfferTimerNoDays()
    doLast()
}

function initLeadMagnetOffer(){
    // grecaptcha js load and grecaptcha.ready
    // to remove 'disable' class on .magnet-btn-attach-clk button
    // is managed in offer/offer_main_magnet.twig
    disableModalOpenCheck()
    doLast()
    
    handleOfferTimer()
    handleOfferTimerNoDays()

    attachHeaderBuyButtonClick()
    attachToCheckoutButtonClick()
    attachMagnetEmailSend()
}

function initFreemiumOffer(){
    disableModalOpenCheck()
    doLast()

    reviewCarouselSetUp()

    const plan = allPlans[selectedPlan]
    
    updateBuyButtonCta(plan.label)

    attachHeaderBuyButtonClickFreemiumOffer()
    handleMobileBottomCtaButton()
    attachBuyButtonClickFreemiumOffer()
    attachToCheckoutButtonClick()

    handleOfferTimer()
    handleOfferTimerNoDays()
}

function initBundleOfferV2(){
    // execute doLast after disableModalOpenCheck
    disableModalOpenCheck()
    doLast()
    
    reviewCarouselSetUp()

    updateBuyButtonCta("Attiva l'offerta")

    attachBundleV2BuyButtonClick();
    attachToCheckoutButtonClick()
    handleMobileBottomCtaButton()

    handleOfferTimer()
    handleOfferTimerNoDays()
}

$(function () {
    // leavingUserModal not shown because we dont call initNavbar
    initFirebaseApp()
    manageLogin()

    switch (pgRef) {
        case "thankyou-ref":
            initThankyouPage()
            break;
        case "default-ref":
            if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('checkout_viewed');
            initDefaultOffer()
            break;
        case "black-friday-2020-ref":
            if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('checkout_viewed');
            initBlackFriday2020Offer()
            break;
        case "bundle-ref":
            if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('checkout_viewed');
            initBundleOffer()
            break;
        case "lead-magnet-ref":
            initLeadMagnetOffer()
            break;
        case "offerta-freemium-ref":
            initFreemiumOffer()
            break;
        case "offerta-bundle-v2-ref":
            if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('checkout_viewed');
            initBundleOfferV2()
            break;
        default:
            break;
    }
    
});